import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { TuiButton, TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { AutoCompleteLabelModel } from 'src/app/shared/models/helpers/auto-complete-label-model';
import { SelectLabelComponent } from '../select-label/select-label.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'pxc-label-create',
  templateUrl: './label-create.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectLabelComponent, TuiButton, TranslocoDirective],
})
export class LabelCreateComponent implements OnInit {
  private readonly context = inject<TuiDialogContext<string[], Partial<LabelCreateComponent>>>(POLYMORPHEUS_CONTEXT);

  @Input() labels: string[] = this.context.data.labels ?? [];

  labelsToCreate: AutoCompleteLabelModel[];

  ngOnInit(): void {
    this.labelsToCreate = this.labels.map((label) => ({ display: label, value: label }));
  }

  confirm(): void {
    this.context.completeWith(this.labelsToCreate.map((label) => label.display));
  }

  cancel(): void {
    this.context.completeWith(null);
  }
}
